import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/shared-folder';

export class SharedFolderServiceV1 implements types.Handlers {
  constructor(private axios: AxiosInstance) {}
  async createSharedFolder(
    params: types.CreateSharedFolderParameters,
  ): Promise<common.CreateSharedFolderResponse> {
    const { data } = await this.axios.post<common.CreateSharedFolderResponse>(
      `/v1/shared-folders`,
      params.body,
    );
    return data;
  }
  async deleteSharedFolder(params: types.DeleteSharedFolderParameters): Promise<void> {
    await this.axios.delete<void>(`/v1/shared-folders/${params.path.sharedFolderId}`);
  }

  async getSharedFolder(
    params: types.GetSharedFolderParameters,
  ): Promise<types.GetSharedFolderResponse> {
    return (
      await this.axios.get<Promise<types.GetSharedFolderResponse>>(
        `/v1/shared-folders/${params.path.sharedFolderId}`,
      )
    ).data;
  }

  async getRootFolders(params: types.GetRootFoldersParameters): Promise<common.GetFoldersResponse> {
    return (
      await this.axios.get<Promise<common.GetFoldersResponse>>(
        `/v1/shared-folders/${params.path.sharedFolderId}/folders`,
        { params: params.query },
      )
    ).data;
  }

  async getSubFolders(params: types.GetSubFoldersParameters): Promise<common.GetFoldersResponse> {
    return (
      await this.axios.get<Promise<common.GetFoldersResponse>>(
        `/v1/shared-folders/${params.path.sharedFolderId}/folders/${params.path.folderId}`,
        { params: params.query },
      )
    ).data;
  }

  async getFiles(params: types.GetFilesParameters): Promise<common.GetFilesResponse> {
    return (
      await this.axios.get<Promise<common.GetFilesResponse>>(
        `/v1/shared-folders/${params.path.sharedFolderId}/files/${params.path.folderId}`,
        { params: params.query },
      )
    ).data;
  }

  async getFileVersionUrl(
    params: types.GetFileVersionUrlParameters,
  ): Promise<common.GetUrlResponse> {
    return (
      await this.axios.get<Promise<common.GetUrlResponse>>(
        `/v1/shared-folders/${params.path.sharedFolderId}/file-version/${params.path.fileVersionId}/url`,
        { params: params.query },
      )
    ).data;
  }
}
